// src/GatewayApiDocs.js
import React, { useContext, useState } from 'react';
import { AuthContext } from './context/AuthContext';
import SolumToolSuiteLayout from './SolumToolSuiteLayout';
import './styles/GatewayApiDocs.css';

// Real response from gateway 172.16.0.42 (firmware N1.3.17.0)
const realConfigResponse = {
  "siteCode": "6070",
  "ipServer": "172.16.3.7",
  "ipTimeServer": "time.google.com",
  "ipDefGw": "172.16.0.1",
  "ipDns": "172.16.0.1",
  "ip": "172.16.0.42",
  "netmask": "255.255.255.0",
  "mac": "D02544FFFE1D6F60",
  "totalNumGway": 20,
  "machId": 0,
  "chWakeup": 11,
  "chData": 74,
  "refreshPeriod": 1,
  "slotTotal": 3,
  "slotActive": 1,
  "wuTagSize": 1536,
  "verDaemon": "N1.3.17.0",
  "setupMemo": "G5",
  "webServerPort": "80,443s",
  "refreshStart": 5,
  "refreshEnd": 7,
  "refreshInterval": 24,
  "refreshMode": 1,
  "timeZone": "GMT+5:00",
  "gMode": 9,
  "locStr": "KOREA",
  "supportedMode": 9,
  "ipServerUrl": ":9002/core/AccessPoints/D02544FFFE1D6F60",
  "wuTagCnt": 1000,
  "ntpInterval": 300,
  "wTxPower": 10,
  "enableTelnet": 1,
  "sleepTime": 10,
  "companyCode": "SOLUM",
  "storeCode": "E69",
  "flexibleDefault": 0,
  "serverSsl": 1,
  "chBeacon": 20,
  "integMachId": 1,
  "totalIntegMachId": 40,
  "wakeupOrder": 6,
  "chScan": 1,
  "phyMode": 0,
  "aesEnable": 0,
  "assetPeriod": 1440,
  "assetUrl": "",
  "batteryIcon": 0,
  "ipDns2": "0.0.0.0",
  "enableStatus7": 1,
  "logoDisplayTime": 0,
  "gatewayFwUrl": ":9002/dashboardservice/common/otamanager/api/gw/getFirmwareFile/9",
  "tapGoUrl": "",
  "shoeTagUrl": "",
  "hostName": "",
  "sendLowBattery": 0,
  "limitStatus": 200,
  "netCheck": 0,
  "tagRxTime": 100,
  "ipRegisterServer": "",
  "registerUrl": "",
  "pickingUrl": ":9002/core/AccessPoints/D02544FFFE1D6F60",
  "cloudUrl": "",
  "divisionCode": 0,
  "whiteListEnabled": 0,
  "tagAliveTime": 6,
  "apiVersion": 1,
  "chAlive": 78,
  "chLbs": 78,
  "lostTime": 0,
  "manufactureMode": 0,
  "otaCount": 10,
  "beaconLossLimit": 10,
  "reactivationRetryLimit": 2,
  "scanPeriodSet": 0,
  "segConfig": 0,
  "segNum": 0,
  "dTxPower": 10,
  "ifMode": 1,
  "ipRabbitMqUrl": "rabbitmq.solumdash.cloud",
  "mqVhost": "",
  "mqPort": 0,
  "mqId": "",
  "resyncEnable": 1,
  "verModem": "V253",
  "verNsp": "9999",
  "verNcp": "176",
  "verNap": "178",
  "verRootfs": "20230322",
  "verKernel": "20200312",
  "dhcpEnabled": 1,
  "dhcpCompleted": 1,
  "enableReport": 1,
  "pollPeriod": 5,
  "pollCount": 24,
  "logEnable": 0,
  "sendEnable": 0,
  "logMode": 0,
  "logSuccess": 0,
  "channelList": "",
  "wifiEnabled": 0,
  "proxyEnabled": 0,
  "proxyUrl": "",
  "apiCompatibility": 1,
  "result": true
};

// All Gateway GET Endpoints
const gatewayGetEndpoints = [
  {
    endpoint: '/api/v2/gw/config',
    description: 'Get full gateway configuration (80+ fields)',
    implemented: true,
    response: realConfigResponse
  },
  {
    endpoint: '/api/v2/gw/status',
    description: 'Get gateway status (tags, queues, memory)',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/gwmac',
    description: 'Get gateway MAC address',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/diagnostic',
    description: 'Get diagnostic information',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/csr',
    description: 'Get certificate signing request',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/ntpcheck',
    description: 'Check NTP status',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/logstatus',
    description: 'Get logging status',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/rfmode0',
    description: 'Get RF mode 0 settings',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/rfmode1',
    description: 'Get RF mode 1 settings',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
  {
    endpoint: '/api/v2/gw/EnablingTelnetSvc',
    description: 'Check telnet service status',
    implemented: false,
    response: { "result": false, "resultCode": -42, "errorMessage": "-42" }
  },
];

// All Gateway POST Endpoints
const gatewayPostEndpoints = [
  { endpoint: '/api/v2/gw/config', description: 'Update gateway configuration', body: '{"key": "MD5_KEY", "ipDns": "8.8.8.8", "setupMemo": "My GW"}' },
  { endpoint: '/api/v2/gw/config/withoutReboot', description: 'Update config without reboot', body: '{"key": "MD5_KEY", "fieldName": "value"}' },
  { endpoint: '/api/v2/gw/rb', description: 'Reboot gateway (alias: gw/reboot)', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/sshd', description: 'Enable/disable SSH', body: '{"key": "MD5_KEY", "enableSsh": 1}' },
  { endpoint: '/api/v2/gw/fw', description: 'Firmware update', body: '{"key": "MD5_KEY", "fwUrl": "http://..."}' },
  { endpoint: '/api/v2/gw/fwNew', description: 'Firmware update (new method)', body: '{"key": "MD5_KEY", "fwUrl": "http://..."}' },
  { endpoint: '/api/v2/gw/gwRootfs', description: 'Root filesystem update', body: '{"key": "MD5_KEY", "rootfsUrl": "http://..."}' },
  { endpoint: '/api/v2/gw/crt', description: 'Upload certificate', body: '{"key": "MD5_KEY", "cert": "base64..."}' },
  { endpoint: '/api/v2/gw/dhcp', description: 'DHCP configuration', body: '{"key": "MD5_KEY", "dhcpEnabled": 1}' },
  { endpoint: '/api/v2/gw/ipaddress', description: 'IP address configuration', body: '{"key": "MD5_KEY", "ip": "x.x.x.x", "netmask": "...", "gateway": "..."}' },
  { endpoint: '/api/v2/gw/poll', description: 'Poll/heartbeat', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/reporting', description: 'Reporting configuration', body: '{"key": "MD5_KEY", "enableReport": 1}' },
  { endpoint: '/api/v2/gw/resetdb', description: 'Reset database', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/dbdump', description: 'Database dump', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/logenable', description: 'Enable/disable logging', body: '{"key": "MD5_KEY", "logEnable": 1}' },
  { endpoint: '/api/v2/gw/tlsdebug', description: 'TLS debug settings', body: '{"key": "MD5_KEY", "tlsDebug": 1}' },
  { endpoint: '/api/v2/gw/usb', description: 'USB configuration', body: '{"key": "MD5_KEY", "usbEnable": 1}' },
  { endpoint: '/api/v2/gw/chlist', description: 'Channel list configuration', body: '{"key": "MD5_KEY", "chWakeup": 11, "chData": 74}' },
  { endpoint: '/api/v2/gw/wakeuporder', description: 'Wakeup order configuration', body: '{"key": "MD5_KEY", "wakeupOrder": 6}' },
  { endpoint: '/api/v2/gw/lbsconfig', description: 'LBS (Location) configuration', body: '{"key": "MD5_KEY", "lbsEnabled": 1, "lbsUrl": "..."}' },
  { endpoint: '/api/v2/gw/autoreboot', description: 'Auto reboot scheduling', body: '{"key": "MD5_KEY", "autoRebootHour": 3}' },
  { endpoint: '/api/v2/gw/freezerota', description: 'Freezer OTA configuration', body: '{"key": "MD5_KEY", "freezerOtaEnabled": 1}' },
  { endpoint: '/api/v2/gw/sendStatus', description: 'Force send status', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/acs', description: 'ACS (Access Control) settings', body: '{"key": "MD5_KEY", "acsEnable": 1}' },
  { endpoint: '/api/v2/gw/checkPeri', description: 'Check peripherals', body: '{"key": "MD5_KEY"}' },
  { endpoint: '/api/v2/gw/enablewebui', description: 'Enable/disable web UI', body: '{"key": "MD5_KEY", "enableWebUi": 1}' },
  { endpoint: '/api/v2/gw/rftest', description: 'RF test mode', body: '{"key": "MD5_KEY", "rfTestMode": 1}' },
  { endpoint: '/api/v2/gw/changeTagSiteCode', description: 'Change tag site code', body: '{"key": "MD5_KEY", "siteCode": "0101"}' },
  { endpoint: '/api/v2/gw/proxyConfig', description: 'Proxy configuration', body: '{"key": "MD5_KEY", "proxyHost": "...", "proxyPort": 8080}' },
  { endpoint: '/api/v2/gw/wifiConfig', description: 'WiFi configuration', body: '{"key": "MD5_KEY", "ssid": "...", "password": "..."}' },
  { endpoint: '/api/v2/gw/stdInfConfig', description: 'Standard interface configuration', body: '{"key": "MD5_KEY", "stdInfEnabled": 1}' },
  { endpoint: '/api/v2/gw/cert802_1x', description: '802.1x certificate', body: '{"key": "MD5_KEY", "cert": "base64..."}' },
  { endpoint: '/api/v2/gw/rabbitmqConfig', description: 'RabbitMQ configuration', body: '{"key": "MD5_KEY", "mqHost": "...", "mqVhost": "/"}' },
  { endpoint: '/api/v2/gw/rabbitmqCrt', description: 'RabbitMQ certificate', body: '{"key": "MD5_KEY", "cert": "base64..."}' },
  { endpoint: '/api/v2/gw/rabbitmqPeriod', description: 'RabbitMQ period settings', body: '{"key": "MD5_KEY", "mqPeriod": 60}' },
  { endpoint: '/api/v2/gw/servicebusKey', description: 'Service bus key configuration', body: '{"key": "MD5_KEY", "servicebusKey": "..."}' },
];

// All Tag Endpoints
const tagEndpoints = [
  { endpoint: '/api/v2/tag/attachtag', description: 'Attach/assign tag' },
  { endpoint: '/api/v4/tag/attachtag', description: 'Attach/assign tag (v4)' },
  { endpoint: '/api/v2/tag/unassign', description: 'Unassign tag' },
  { endpoint: '/api/v2/tag/delete', description: 'Delete tag' },
  { endpoint: '/api/v2/tag/image', description: 'Send image to tag' },
  { endpoint: '/api/v2/tag/blinkled', description: 'Blink tag LED' },
  { endpoint: '/api/v4/tag/blinkled', description: 'Blink tag LED (v4)' },
  { endpoint: '/api/v2/tag/alive', description: 'Tag alive/keepalive' },
  { endpoint: '/api/v2/tag/fw', description: 'Tag firmware update' },
  { endpoint: '/api/v2/tag/schedule', description: 'Tag schedule update' },
  { endpoint: '/api/v2/tag/segment', description: 'Tag segment update' },
  { endpoint: '/api/v2/tag/multisegment', description: 'Multi-segment update' },
  { endpoint: '/api/v2/tag/multiupdate', description: 'Multi-field update (image, LED, NFC, etc.)' },
  { endpoint: '/api/v2/tag/nfc', description: 'NFC data update' },
  { endpoint: '/api/v2/tag/rfid', description: 'RFID data update' },
  { endpoint: '/api/v2/tag/oos', description: 'Out of stock indicator' },
  { endpoint: '/api/v2/tag/lbs', description: 'LBS (location) update' },
  { endpoint: '/api/v2/tag/lbsalarm', description: 'LBS alarm' },
  { endpoint: '/api/v2/tag/lbsanchor', description: 'LBS anchor configuration' },
  { endpoint: '/api/v2/tag/lbscommand', description: 'LBS command' },
  { endpoint: '/api/v2/tag/shortaddr', description: 'Short address assignment' },
  { endpoint: '/api/v2/tag/reSendStatus', description: 'Resend tag status' },
  { endpoint: '/api/v2/tag/camerainfo', description: 'Camera info (for camera tags)' },
  { endpoint: '/api/v2/tag/snapshot', description: 'Camera snapshot' },
  { endpoint: '/api/v2/tag/temperatureConfig', description: 'Temperature tag configuration' },
];

// Data & Other Endpoints
const dataEndpoints = [
  { method: 'GET', endpoint: '/api/v2/data/energy', description: 'Get energy/power data' },
  { method: 'GET', endpoint: '/api/otaschedulebygw/', description: 'OTA schedule by gateway' },
];

// CGI Endpoints
const cgiEndpoints = [
  { endpoint: '/cgi-bin/login.cgi', description: 'Web login' },
  { endpoint: '/cgi-bin/gatewayConfiguration.cgi', description: 'Gateway configuration' },
  { endpoint: '/cgi-bin/networkConfiguration.cgi', description: 'Network configuration' },
  { endpoint: '/cgi-bin/networkConfigurationWiFi.cgi', description: 'WiFi configuration' },
  { endpoint: '/cgi-bin/serverConfiguration.cgi', description: 'Server configuration' },
  { endpoint: '/cgi-bin/securityConfiguration.cgi', description: 'Security configuration' },
  { endpoint: '/cgi-bin/firmwareUpdate.cgi', description: 'Firmware update' },
  { endpoint: '/cgi-bin/changePassword.cgi', description: 'Change password' },
  { endpoint: '/cgi-bin/decideNetworkConfig.cgi', description: 'Network config decision' },
];

// Config fields grouped
const configFields = {
  'Network': ['ip', 'netmask', 'ipDefGw', 'ipDns', 'ipDns2', 'dhcpEnabled', 'ifMode'],
  'Server': ['ipServer', 'ipServerUrl', 'serverSsl', 'apiVersion', 'webServerPort', 'ipRegisterServer', 'registerUrl', 'apiKeyRegisterServer', 'cloudUrl', 'apiKeyCloudServer', 'ipMqServer', 'ipRabbitMqUrl', 'mqVhost', 'mqId', 'mqPass', 'mqPort'],
  'Site/Store': ['siteCode', 'storeCode', 'companyCode', 'divisionCode', 'locStr', 'timeZone', 'hostName'],
  'RF Settings': ['chWakeup', 'chData', 'chBeacon', 'chScan', 'chAlive', 'chLbs', 'wTxPower', 'dTxPower', 'wakeupOrder', 'phyMode', 'gMode'],
  'Slot/Timing': ['slotTotal', 'slotActive', 'refreshPeriod', 'refreshStart', 'refreshEnd', 'refreshInterval', 'refreshMode', 'ntpInterval', 'sleepTime'],
  'Features': ['enableTelnet', 'enableStatus7', 'aesEnable', 'logEnable', 'flexibleDefault', 'logoDisplayTime', 'batteryIcon', 'sendLowBattery', 'limitStatus', 'netCheck', 'tagRxTime', 'tagAliveTime', 'whiteListEnabled', 'resyncEnable', 'manufactureMode'],
  'Asset/Picking/LBS': ['assetPeriod', 'assetUrl', 'tapGoUrl', 'shoeTagUrl', 'pickingUrl', 'lbsurl', 'lostTime', 'beaconLossLimit'],
  'OTA': ['gatewayFwUrl', 'otaManagerUrl', 'otaCount', 'sensorUrl', 'cameraUrl'],
  'Machine': ['machId', 'integMachId', 'totalIntegMachId', 'totalNumGway'],
  'Versions (read-only)': ['verDaemon', 'verModem', 'verNsp', 'verNcp', 'verNap', 'verRootfs', 'verKernel'],
  'Other': ['mac', 'setupMemo', 'wuTagSize', 'wuTagCnt', 'acsEnable', 'segConfig', 'segNum', 'reactivationRetryLimit', 'scanPeriodSet', 'updatePageUnlock'],
};

// Expandable GET Endpoint Row with JSON response
const GetEndpointRow = ({ endpoint, description, response, implemented }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`endpoint-row ${expanded ? 'expanded' : ''}`}>
      <div className="endpoint-header" onClick={() => setExpanded(!expanded)}>
        <span className="method-badge method-get">GET</span>
        <span className="endpoint-path">{endpoint}</span>
        <span className="endpoint-desc">{description}</span>
        {!implemented && <span className="not-implemented-badge">-42</span>}
        <span className="expand-icon">{expanded ? '▼' : '▶'}</span>
      </div>
      {expanded && (
        <div className="endpoint-details">
          <div className="detail-section">
            <h4>Response {implemented ? '(200 OK)' : '(Not implemented on firmware N1.3.17.0)'}</h4>
            <pre className={`code-block ${implemented ? 'response-block' : 'error-block'}`}>
{JSON.stringify(response, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

// Expandable POST Endpoint Row
const PostEndpointRow = ({ endpoint, description, body }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`endpoint-row ${expanded ? 'expanded' : ''}`}>
      <div className="endpoint-header" onClick={() => setExpanded(!expanded)}>
        <span className="method-badge method-post">POST</span>
        <span className="endpoint-path">{endpoint}</span>
        <span className="endpoint-desc">{description}</span>
        <span className="expand-icon">{expanded ? '▼' : '▶'}</span>
      </div>
      {expanded && (
        <div className="endpoint-details">
          <div className="detail-section">
            <h4>Request Body (multipart form-data: files={'{"data": JSON}'})</h4>
            <pre className="code-block">
{body}
            </pre>
          </div>
          <div className="detail-section">
            <h4>Success Response (200 OK)</h4>
            <pre className="code-block response-block">
{`{
  "result": true,
  "resultCode": 1,
  "errorMessage": "1"
}`}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

// Simple Endpoint Row (no expanding)
const SimpleEndpointRow = ({ method, endpoint, description }) => (
  <div className="endpoint-row-simple" style={{ borderLeft: `4px solid ${method === 'GET' ? '#61affe' : '#49cc90'}` }}>
    <span className={`method-badge method-${method?.toLowerCase() || 'post'}`}>{method || 'POST'}</span>
    <span className="endpoint-path">{endpoint}</span>
    <span className="endpoint-desc">{description}</span>
  </div>
);

function GatewayApiDocs() {
  const { user } = useContext(AuthContext);
  const [expandedSections, setExpandedSections] = useState({
    auth: true,
    gw_get: true,
    gw_post: false,
    tag: false,
    data: false,
    cgi: false,
    config: false,
    examples: false,
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  // Check if user is admin
  if (user?.role !== 'admin' && !user?.isSuperAdmin) {
    return (
      <SolumToolSuiteLayout>
        <div className="gateway-api-docs">
          <div className="access-denied">
            <h2>Access Denied</h2>
            <p>This page is only accessible to Administrators.</p>
          </div>
        </div>
      </SolumToolSuiteLayout>
    );
  }

  return (
    <SolumToolSuiteLayout>
      <div className="gateway-api-docs swagger-style">
        {/* Header */}
        <div className="api-header">
          <h1>SOLUM Gateway API</h1>
          <span className="version-badge">v2.0</span>
        </div>
        <p className="api-description">
          Direct Gateway API Endpoints - Extracted from gateway firmware (nsp daemon)
        </p>
        <div className="base-url">
          <strong>Base URL:</strong> <code>http://{'{gateway_ip}'}</code> or <code>https://{'{gateway_ip}'}</code>
        </div>

        {/* Authentication Section */}
        <div className="api-section auth-section">
          <div className="section-header" onClick={() => toggleSection('auth')}>
            <span className="section-icon">{expandedSections.auth ? '▼' : '▶'}</span>
            <h2>Authentication</h2>
          </div>
          {expandedSections.auth && (
            <div className="section-content">
              <p>Most POST endpoints require an MD5 key. Key = MD5(gateway_ip + "admin")</p>
              <p>Passed as JSON in multipart form data: <code>{'files = {\'data\': json.dumps({\'key\': key, ...})}'}</code></p>
              <pre className="code-block">
{`import hashlib, json, requests

gateway_ip = "172.16.0.42"
key = hashlib.md5(f'{gateway_ip}admin'.encode()).hexdigest()
# Result: 35da3fc70b03e892c2adb20b68e1999a

# GET request (no auth needed):
response = requests.get(f'http://{gateway_ip}/api/v2/gw/config', timeout=5)
config = response.json()

# POST request (auth required):
data = {'key': key, 'enableSsh': 1}
files = {'data': json.dumps(data)}
response = requests.post(f'http://{gateway_ip}/api/v2/gw/sshd', files=files, timeout=10)
result = response.json()
# Returns: {'result': True, 'resultCode': 1, 'errorMessage': '1'}`}
              </pre>
            </div>
          )}
        </div>

        {/* Gateway GET Endpoints */}
        <div className="api-section get-section">
          <div className="section-header" onClick={() => toggleSection('gw_get')}>
            <span className="section-icon">{expandedSections.gw_get ? '▼' : '▶'}</span>
            <h2>Gateway Endpoints - GET</h2>
            <span className="endpoint-count">{gatewayGetEndpoints.length} endpoints</span>
          </div>
          {expandedSections.gw_get && (
            <div className="endpoints-list">
              {gatewayGetEndpoints.map((ep, idx) => (
                <GetEndpointRow key={idx} {...ep} />
              ))}
            </div>
          )}
        </div>

        {/* Gateway POST Endpoints */}
        <div className="api-section post-section">
          <div className="section-header" onClick={() => toggleSection('gw_post')}>
            <span className="section-icon">{expandedSections.gw_post ? '▼' : '▶'}</span>
            <h2>Gateway Endpoints - POST</h2>
            <span className="endpoint-count">{gatewayPostEndpoints.length} endpoints</span>
          </div>
          {expandedSections.gw_post && (
            <div className="endpoints-list">
              {gatewayPostEndpoints.map((ep, idx) => (
                <PostEndpointRow key={idx} {...ep} />
              ))}
            </div>
          )}
        </div>

        {/* Tag Endpoints */}
        <div className="api-section post-section">
          <div className="section-header" onClick={() => toggleSection('tag')}>
            <span className="section-icon">{expandedSections.tag ? '▼' : '▶'}</span>
            <h2>Tag Endpoints - POST</h2>
            <span className="endpoint-count">{tagEndpoints.length} endpoints</span>
          </div>
          {expandedSections.tag && (
            <div className="endpoints-list">
              {tagEndpoints.map((ep, idx) => (
                <SimpleEndpointRow key={idx} method="POST" endpoint={ep.endpoint} description={ep.description} />
              ))}
            </div>
          )}
        </div>

        {/* Data & Other Endpoints */}
        <div className="api-section get-section">
          <div className="section-header" onClick={() => toggleSection('data')}>
            <span className="section-icon">{expandedSections.data ? '▼' : '▶'}</span>
            <h2>Data & Other Endpoints</h2>
            <span className="endpoint-count">{dataEndpoints.length} endpoints</span>
          </div>
          {expandedSections.data && (
            <div className="endpoints-list">
              {dataEndpoints.map((ep, idx) => (
                <SimpleEndpointRow key={idx} method={ep.method} endpoint={ep.endpoint} description={ep.description} />
              ))}
            </div>
          )}
        </div>

        {/* CGI Endpoints */}
        <div className="api-section cgi-section">
          <div className="section-header" onClick={() => toggleSection('cgi')}>
            <span className="section-icon">{expandedSections.cgi ? '▼' : '▶'}</span>
            <h2>CGI Endpoints (Web UI - Port 55755 HTTPS)</h2>
            <span className="endpoint-count">{cgiEndpoints.length} endpoints</span>
          </div>
          {expandedSections.cgi && (
            <div className="endpoints-list">
              {cgiEndpoints.map((ep, idx) => (
                <div key={idx} className="endpoint-row-simple" style={{ borderLeft: '4px solid #888' }}>
                  <span className="method-badge" style={{ background: '#888' }}>CGI</span>
                  <span className="endpoint-path">{ep.endpoint}</span>
                  <span className="endpoint-desc">{ep.description}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Config Fields */}
        <div className="api-section config-section">
          <div className="section-header" onClick={() => toggleSection('config')}>
            <span className="section-icon">{expandedSections.config ? '▼' : '▶'}</span>
            <h2>Configuration Fields</h2>
          </div>
          {expandedSections.config && (
            <div className="section-content">
              <p>Fields available via <code>/api/v2/gw/config</code> GET (read) and POST (write):</p>
              <div className="config-grid">
                {Object.entries(configFields).map(([category, fields]) => (
                  <div key={category} className="config-group">
                    <h4>{category}</h4>
                    <code>{fields.join(', ')}</code>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Code Examples */}
        <div className="api-section examples-section">
          <div className="section-header" onClick={() => toggleSection('examples')}>
            <span className="section-icon">{expandedSections.examples ? '▼' : '▶'}</span>
            <h2>Code Examples</h2>
          </div>
          {expandedSections.examples && (
            <div className="section-content">
              <h4>Example 1: Get Full Gateway Configuration</h4>
              <pre className="code-block">
{`import requests

gateway_ip = "172.16.0.42"
response = requests.get(f'http://{gateway_ip}/api/v2/gw/config', timeout=5)
config = response.json()

print(f"Site Code: {config.get('siteCode')}")
print(f"Store Code: {config.get('storeCode')}")
print(f"Server IP: {config.get('ipServer')}")
print(f"Firmware: {config.get('verDaemon')}")`}
              </pre>

              <h4>Example 2: Update Gateway Configuration (Partial Update)</h4>
              <pre className="code-block">
{`import requests, hashlib, json

gateway_ip = "172.16.0.42"
key = hashlib.md5(f'{gateway_ip}admin'.encode()).hexdigest()

# Only send the fields you want to change
data = {
    'key': key,
    'ipDns': '8.8.8.8',
    'ipTimeServer': 'time.google.com',
    'setupMemo': 'My Gateway Name'
}

files = {'data': json.dumps(data)}
response = requests.post(f'http://{gateway_ip}/api/v2/gw/config', files=files, timeout=10)
print(response.json())`}
              </pre>

              <h4>Example 3: Enable SSH on Gateway</h4>
              <pre className="code-block">
{`import requests, hashlib, json

gateway_ip = "172.16.0.42"
key = hashlib.md5(f'{gateway_ip}admin'.encode()).hexdigest()

# Enable SSH (enableSsh=1) or disable (enableSsh=0)
data = {'key': key, 'enableSsh': 1}
files = {'data': json.dumps(data)}
response = requests.post(f'http://{gateway_ip}/api/v2/gw/sshd', files=files, timeout=10)
print(response.json())
# Returns: {'result': True, 'resultCode': 1, 'errorMessage': '1'}`}
              </pre>

              <h4>Example 4: Reboot Gateway</h4>
              <pre className="code-block">
{`import requests, hashlib, json

gateway_ip = "172.16.0.42"
key = hashlib.md5(f'{gateway_ip}admin'.encode()).hexdigest()

data = {'key': key}
files = {'data': json.dumps(data)}
response = requests.post(f'http://{gateway_ip}/api/v2/gw/rb', files=files, timeout=10)
print(response.json())`}
              </pre>

              <h4>Example 5: Check if Gateway is Online (Quick Probe)</h4>
              <pre className="code-block">
{`import requests

def check_gateway(ip, timeout=0.5):
    try:
        response = requests.get(f'http://{ip}/api/v2/gw/config', timeout=timeout)
        if response.status_code == 200:
            config = response.json()
            mac = config.get('mac', '')
            # SOLUM gateways have MAC starting with D02544
            if mac.upper().startswith('D02544'):
                return True, config
        return False, None
    except:
        return False, None

is_online, config = check_gateway("172.16.0.42")
if is_online:
    print(f"Gateway online: {config.get('mac')}")`}
              </pre>

              <h4>CURL Examples</h4>
              <pre className="code-block">
{`# GET config (no auth needed)
curl http://172.16.0.42/api/v2/gw/config

# POST with key (enable SSH)
# First generate key: echo -n "172.16.0.42admin" | md5sum
# Result: 35da3fc70b03e892c2adb20b68e1999a
curl -X POST http://172.16.0.42/api/v2/gw/sshd \\
  -F 'data={"key":"35da3fc70b03e892c2adb20b68e1999a","enableSsh":1}'

# POST config update
curl -X POST http://172.16.0.42/api/v2/gw/config \\
  -F 'data={"key":"35da3fc70b03e892c2adb20b68e1999a","ipDns":"8.8.8.8"}'`}
              </pre>
            </div>
          )}
        </div>

        {/* Common Errors */}
        <div className="api-section errors-section">
          <div className="section-content">
            <h3>Common Response Codes & Troubleshooting</h3>
            <ul className="error-list">
              <li><code>result: true, resultCode: 1</code> - Success</li>
              <li><code>resultCode: -42</code> - Endpoint not implemented on this firmware version</li>
              <li><code>resultCode: -1</code> - Invalid request or missing key</li>
              <li><code>Invalid key</code> - MD5 key incorrect. Use: <code>hashlib.md5(f'{'{ip}'}admin'.encode()).hexdigest()</code></li>
              <li><code>SIL is executing another API Command</code> - Gateway busy, wait and retry</li>
              <li><strong>Connection timeout</strong> - Check if gateway is powered on and connected to network</li>
              <li><strong>Response is not JSON</strong> - Check HTTP vs HTTPS, verify endpoint path</li>
            </ul>
          </div>
        </div>

      </div>
    </SolumToolSuiteLayout>
  );
}

export default GatewayApiDocs;
